import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getCount = (state: RootState) => state.pages.editor.canvas.errorRequestCount;

const getErrorRequestCount = createSelector([getCount], (count) => count);

export default getErrorRequestCount;
